import springApi from '../../services/springApi'

export const getSegments = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/segments', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getSegment = (id, params) => (
	new Promise((resolve, reject) => {
		springApi()
			.get(`/segments/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)